export default {
	state: {
		novaChave: {}
	},
	getters: {
		"novaChave": state => state.novaChave
	},
	mutations: {
		setNovaChave(state, payload) {
			state.novaChave = payload
		}
	},
	actions: {
		atualizarEstadoNovaChave({ commit }, payload) {
			commit('setNovaChave', payload)
		}
	}
};